import React from 'react';
import { Award, Users, TrendingUp } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';

const SuccessRatesSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const stats = [
    {
      icon: Award,
      number: t.yearsOfExperience,
      label: t.yearsOfExperienceLabel,
    },
    {
      icon: TrendingUp,
      number: t.overallSuccessRate,
      label: t.overallSuccessRateLabel,
    },
    {
      icon: Users,
      number: t.satisfiedClients,
      label: t.satisfiedClientsLabel,
    },
  ];

  return (
    <section className="py-20 bg-gray-50 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#c4a35a]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#c4a35a]/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#c4a35a] mb-4">
            Case Success Rates
          </h2>
          <div className="w-20 h-1 bg-[#c4a35a] mx-auto" />
        </div>

        {/* Three Stat Boxes in a Row */}
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {stats.map((stat, index) => {
            const Icon = stat.icon;
            return (
              <div
                key={index}
                className="bg-[#1a1d2e] border border-[#c4a35a]/30 rounded-xl p-8 hover:border-[#c4a35a]/60 hover:shadow-lg hover:scale-105 transition-all duration-300"
              >
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-[#c4a35a]/10 rounded-full flex items-center justify-center mb-4">
                    <Icon className="w-8 h-8 text-[#c4a35a]" />
                  </div>
                  <div className="text-5xl md:text-6xl font-bold text-[#c4a35a] mb-3">
                    {stat.number}
                  </div>
                  <p className="text-white text-base md:text-lg font-medium" style={{ direction: language === 'ar' || language === 'ku' ? 'rtl' : 'ltr' }}>
                    {stat.label}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SuccessRatesSection;